import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {GameTypeEnum, UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'

export class UIMMatchmakingSearching1v1View extends UIMMatchmakingSearchingView {
    constructor(matchmakingController: UIMMatchmakingController, isRanked: boolean) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const player1v1Ranked: TranslationObject = {key: 'strings:homePage.matchmakingPopup.ranked1v1'}
        const player1v1Unranked: TranslationObject = {key: 'strings:homePage.unranked.1v1'}
        const title = isRanked ? player1v1Ranked : player1v1Unranked
        const imageSrc = LobbyImage.GameMode1v1

        super(matchmakingController, title, imageSrc, loadingText, isRanked, GameTypeEnum.Classic1v1)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
